var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPrimecast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_primecast",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160.971,
    height: 77.293,
    viewBox: "0 0 160.971 77.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_164",
    "data-name": "\\u9577\\u65B9\\u5F62 164",
    width: 160.971,
    height: 77.293,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_273",
    "data-name": "\\u30D1\\u30B9 273",
    d: "M238.762,137.762l4.878,8.042h-9.786Zm-1.439-1.9-8.951,14.906h2.472l2-3.258h12l2.026,3.258h2.477l-9.223-14.852-.034-.054Z",
    transform: "translate(-123.6 -73.533)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_133",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_132",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_274",
    "data-name": "\\u30D1\\u30B9 274",
    d: "M284.806,142.312c-.735,0-1.481.015-2.2.03-1.438.029-2.923.06-4.38-.03-.689-.006-1.906-.13-2.322-.894a2.323,2.323,0,0,1-.2-1.169,3.285,3.285,0,0,1,.2-1.388c.554-1.065,1.856-1.154,3.141-1.154.745,0,1.5-.017,2.238-.034s1.485-.034,2.222-.034,1.482.031,2.256.064l.445.019c1.853.126,2.37.677,2.4,2.56l0,.113h2.105v-.115c-.024-4.422-2.932-4.445-6.626-4.445h-.118c-.715,0-1.436,0-2.161.007s-1.463.007-2.193.007c-3.4,0-6.217.314-6.217,4.168,0,1.923.679,3.148,2.075,3.745a12.529,12.529,0,0,0,4.613.529h.055c.812,0,1.621-.01,2.421-.019.782-.009,1.556-.019,2.316-.019.242,0,.481,0,.713-.008,1.177-.022,2.2-.039,2.769.525a2.406,2.406,0,0,1,.539,1.779,3.463,3.463,0,0,1-.186,1.369c-.61,1.032-2.887,1-4.245.99-.152,0-.291,0-.417,0-.682,0-1.382.011-2.086.023s-1.43.023-2.14.023c-.3,0-.582.005-.852.009-1.3.022-2.241.038-2.787-.5a2.985,2.985,0,0,1-.585-2.173v-.31h-2.181v.8a3.908,3.908,0,0,0,.967,2.91c1.04,1.036,2.77,1.126,4.651,1.126l.6,0c1,0,2.028-.012,3.014-.028.787-.013,1.6-.026,2.4-.026,3.124,0,6.075,0,6.075-4.175,0-4.266-2.934-4.266-6.331-4.266",
    transform: "translate(-147.971 -73.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_275",
    "data-name": "\\u30D1\\u30B9 275",
    d: "M312.654,135.865v1.859h7.7V150.77h2.2V137.723h7.627v-1.859Z",
    transform: "translate(-169.216 -73.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_276",
    "data-name": "\\u30D1\\u30B9 276",
    d: "M56.478,144.134c1.787-.484,2.117-1.452,2.117-3.209a9.357,9.357,0,0,0-.39-3.2c-.948-1.647-3.143-1.859-4.95-1.859H41.385v14.906h2.2v-5.834l10.2-.007a2.918,2.918,0,0,1,2.119.573c.525.529.518,1.453.509,2.622,0,.158,0,.321,0,.488v2.157h2.18l.016-2.471c.028-2,.049-3.47-2.131-4.165m-.064-3.628c0,2.229-.816,2.626-3.113,2.626l-9.713-.015v-5.393h9.877c2.315,0,2.949.6,2.949,2.782",
    transform: "translate(-22.399 -73.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_163",
    "data-name": "\\u9577\\u65B9\\u5F62 163",
    width: 2.189,
    height: 14.906,
    transform: "translate(38.384 62.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_277",
    "data-name": "\\u30D1\\u30B9 277",
    d: "M105.075,148.066l-8.841-12.154-.034-.047H92.9v14.906h2.189V138.225l9.282,12.5.034.046h1.49l9.143-12.636v12.636h2.189V135.865h-3.229Z",
    transform: "translate(-50.277 -73.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_278",
    "data-name": "\\u30D1\\u30B9 278",
    d: "M152.714,143.939h12.394v-1.754H152.714v-4.462h12.928v-1.859H150.509V150.77h15.2v-1.852H152.714Z",
    transform: "translate(-81.459 -73.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_279",
    "data-name": "\\u30D1\\u30B9 279",
    d: "M204.186,145.548c0,2.672-.385,3.345-3.272,3.345-.8,0-1.6.011-2.409.023s-1.611.023-2.418.023h-.679c-2.382.007-3.818.009-4.575-.751-.609-.612-.84-1.74-.822-4.022l.021-2.425c.058-3.771.679-4.045,4.525-4.045.782,0,1.557-.017,2.306-.034s1.5-.034,2.258-.034c.314,0,.616,0,.907-.01,1.467-.023,2.626-.043,3.289.609a3.158,3.158,0,0,1,.667,2.334v.318h1.965l.044-.827a4.6,4.6,0,0,0-.462-2.457c-1.128-1.82-3.916-1.794-5.949-1.776-.2,0-.39,0-.573,0-.765,0-1.545,0-2.329.007s-1.593.007-2.386.007c-4.824,0-6.436.827-6.474,5.721l-.038,2.395c-.02,2.3.062,4.294,1.268,5.51.866.873,2.234,1.28,4.306,1.28h7.559c3.628,0,5.355-.694,5.355-4.634v-.677h-2.084Z",
    transform: "translate(-101.631 -73.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_280",
    "data-name": "\\u30D1\\u30B9 280",
    d: "M11.834,135.865H0v14.906H2.2v-5.743h9.352c3.733,0,5.369-.407,5.369-4.3,0-3.86-1.046-4.859-5.091-4.859M2.2,137.724h9.2c2.468,0,3.331.222,3.331,2.708,0,2.328-.755,2.7-3.181,2.7H2.2Z",
    transform: "translate(0 -73.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_281",
    "data-name": "\\u30D1\\u30B9 281",
    d: "M140.42,19.776a3.552,3.552,0,0,1,3.553-3.842,3.5,3.5,0,0,1,3.378,3.889s1.022,5.5-5.932,8.483c0,0-9.3,4.743-17.94-1.3,0,0-4.772-2.682-6.372-11.224a15.035,15.035,0,0,0-3.535-7.227,15.9,15.9,0,0,0-2.2-2.082s-2.907-2.16-.864-5.106c0,0,2.4-3.142,5.931.118a23.6,23.6,0,0,1,6.315,8.837,16.725,16.725,0,0,1,1.305,4.634s.785,4.6,3.417,6.285c0,0,4.193,2.685,8.6,1.453a12.521,12.521,0,0,0,3.686-1.508,1.585,1.585,0,0,0,.656-1.405",
    transform: "translate(-59.416 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_282",
    "data-name": "\\u30D1\\u30B9 282",
    d: "M179.1,86.687s3.967.157,3.693-5.264c0,0,.629-9.977-10.566-14.336A11.824,11.824,0,0,0,161.9,68.108s-5.224,2.611-5.931,10.566c0,0-.2,8.563,5.577,7.737,0,0,3.261-.432,2.514-4.242a6.3,6.3,0,0,0-.746-1.767c-.445-.588-.189-1.742.259-3.582a4.784,4.784,0,0,1,4.219-3.488,7.9,7.9,0,0,1,5.735,2.749,7.637,7.637,0,0,1,2.278,5.892s-1.276,4.223,3.3,4.714",
    transform: "translate(-84.414 -35.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_283",
    "data-name": "\\u30D1\\u30B9 283",
    d: "M153.88,18.647s-1.06-.255-1.492.138l-1.139.707a8.689,8.689,0,0,1-.982.413l-.648.157a.841.841,0,0,0-.432.236,4.6,4.6,0,0,0-1.433,4.831,5.348,5.348,0,0,0,2.838,3.26l.276.169a4.6,4.6,0,0,0,4,1.167,4.917,4.917,0,0,0,3.947-3.751,5.36,5.36,0,0,0-.845-4.183,12.441,12.441,0,0,0-1.747-2.023,3.432,3.432,0,0,0-2.337-1.12",
    transform: "translate(-79.869 -10.048)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimecast);
export default __webpack_public_path__ + "static/media/logo_primecast.b25e34819c8d68111c3ba0ca63913ee9.svg";
export { ForwardRef as ReactComponent };